import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="currentColor"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40 6h-2V4c0-1.1-.9-2-2-2s-2 .9-2 2v2H14V4c0-1.1-.9-2-2-2s-2 .9-2 2v2H8c-2.2 0-4 1.8-4 4v32c0 2.2 1.8 4 4 4h32c2.2 0 4-1.8 4-4V10c0-2.2-1.8-4-4-4m-2 36H10c-1.1 0-2-.9-2-2V16h32v24c0 1.1-.9 2-2 2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendar;
